import axios from 'axios'
import {Message, MessageBox, Notification} from 'element-ui'
import store from '@/store'
import errorCode from '@/utils/errorCode'
import {generateSM4Key, sm2Encrypt, sm2PublicKey, sm4Encrypt, sm4Decrypt} from '@/utils/smCrypto'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
	// axios中请求配置有baseURL选项，表示请求URL公共部分
	baseURL: '/prod-api',
	// 超时
	timeout: 10000
})

// request拦截器
service.interceptors.request.use(config => {
	// 是否需要设置 token
	// const isToken = (config.headers || {}).isToken === false
	// if (getToken() && !isToken) {
	// 	config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
	// }
	config.headers['encryptedkey'] = sm2Encrypt(generateSM4Key(), sm2PublicKey);

	if (config.method === 'get' && config.params) {
		// GET请求参数处理
		let str = sm4Encrypt(JSON.stringify(config.params), generateSM4Key())
		config.params = { '$@$.ecryptedData': str }
	} else if (config.method === 'post' && config.data) {
		// POST请求参数处理
		let str = sm4Encrypt(JSON.stringify(config.data), generateSM4Key())
		config.headers['Content-Type'] = 'application/json;charset=utf-8'
		config.data = { '$@$.ecryptedData': str }
	}

	return config
}, error => {
	console.log(error)
	Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
		// 未设置状态码则默认成功状态
		const code = res.data.code || 200;
		// 获取错误信息
		const message = errorCode[code] || res.data.msg || errorCode['default']

		if (code === 401) {
			MessageBox.confirm(
				'登录状态已过期，您可以继续留在该页面，或者重新登录',
				'系统提示', {
					confirmButtonText: '重新登录',
					cancelButtonText: '取消',
					type: 'warning'
				}
			).then(() => {
				store.dispatch('LogOut').then(() => {
					location.reload() // 为了重新实例化vue-router对象 避免bug
				})
			})
		} else if (code === 500) {
			Message({
				message: message,
				type: 'error'
			})
			return Promise.reject(new Error(message))
		} else if (code !== 200) {
			Notification.error({
				title: message
			})
			return Promise.reject('error')
		} else {
			const resultStr = res.data['$@$.ecryptedData'];
			if (resultStr) {
				const decryptedStr = sm4Decrypt(resultStr, generateSM4Key())
				res.data = JSON.parse(decryptedStr.replace(/\u0000+$/, ''))
			}
			return res.data
		}
	},
	error => {
		console.log('err' + error)
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)

export default service
